import React, { useState, useEffect } from "react";
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  TextField, Button, Checkbox, FormControlLabel
} from "@mui/material";

interface BreakdownDialogProps {
  open: boolean;
  onClose: () => void;
  type: "CATEGORY" | "SEVERITY";
  row: any | null;
  onSubmit: (data: any) => void;
}

export default function BreakdownDialog({ open, onClose, type, row, onSubmit }: BreakdownDialogProps) {
  const [form, setForm] = useState({ id: 0, name: "", description: "", sortOrder: 0, isActive: true });

  useEffect(() => {
    if (row) {
      setForm(row);
    } else {
      setForm({ id: 0, name: "", description: "", sortOrder: 0, isActive: true });
    }
  }, [row]);

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>{row ? `Edit ${type}` : `Create ${type}`}</DialogTitle>
      <DialogContent>
        <TextField
          label="Name"
          fullWidth
          margin="dense"
          value={form.name}
          onChange={(e) => setForm({ ...form, name: e.target.value.toUpperCase() })}
        />
        <TextField
          label="Description"
          fullWidth
          margin="dense"
          value={form.description}
          onChange={(e) => setForm({ ...form, description: e.target.value })}
        />
        <TextField
          label="Sort Order"
          type="number"
          fullWidth
          margin="dense"
          value={form.sortOrder}
          onChange={(e) => setForm({ ...form, sortOrder: Number(e.target.value) })}
        />
        <FormControlLabel
          control={<Checkbox checked={form.isActive} onChange={(e) => setForm({ ...form, isActive: e.target.checked })} />}
          label="Active"
        />
      </DialogContent>
      <DialogActions>
        <Button variant="contained" sx={{ background: 'linear-gradient(135deg, #667eea 0%, #4c5fd7 100%)',
                '&:hover': { background: 'linear-gradient(135deg, #4c5fd7 0%, #c2410c 100%)' } }} onClick={() => onSubmit(form)}>Submit</Button>
        <Button variant="contained" sx={{ background: 'linear-gradient(135deg, #667eea 0%, #4c5fd7 100%)',
                '&:hover': { background: 'linear-gradient(135deg, #4c5fd7 0%, #c2410c 100%)' } }} onClick={onClose}>Cancel</Button>
      </DialogActions>
    </Dialog>
  );
}